(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const states = new WeakMap();
  const randomBetween = (minimum, maximum) => Math.round(minimum + Math.random() * (maximum - minimum));

  function restore(heading) {
    const state = states.get(heading);
    if (!state) return;
    window.clearTimeout(state.cycleTimer);
    window.clearTimeout(state.fadeTimer);
    heading.innerHTML = state.markup;
    if (state.ariaLabel === null) heading.removeAttribute('aria-label');
    else heading.setAttribute('aria-label', state.ariaLabel);
    heading.removeAttribute('data-science-glow-ready');
    states.delete(heading);
  }

  function initialize(root = document) {
    if (reducedMotion.matches) return;
    root.querySelectorAll('.science-glow:not([data-science-glow-ready])').forEach(heading => {
      const state = { markup: heading.innerHTML, ariaLabel: heading.getAttribute('aria-label'), cycleTimer: null, fadeTimer: null };
      const textNodes = [];
      const walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) textNodes.push(walker.currentNode);
      textNodes.forEach(node => {
        const fragment = document.createDocumentFragment();
        [...node.nodeValue].forEach(character => {
          const span = document.createElement('span');
          span.setAttribute('data-science-character', '');
          span.setAttribute('aria-hidden', 'true');
          span.textContent = character;
          fragment.append(span);
        });
        node.replaceWith(fragment);
      });
      heading.setAttribute('aria-label', heading.textContent);
      heading.dataset.scienceGlowReady = 'true';
      states.set(heading, state);
      const characters = [...heading.querySelectorAll('[data-science-character]')].filter(span => /[A-Za-z0-9]/.test(span.textContent));
      const schedule = () => {
        if (states.get(heading) !== state) return;
        window.clearTimeout(state.cycleTimer);
        if (!reducedMotion.matches && !document.hidden) state.cycleTimer = window.setTimeout(trigger, randomBetween(2000, 4000));
      };
      const trigger = () => {
        if (states.get(heading) !== state || reducedMotion.matches || document.hidden) return;
        const chosen = new Set();
        const count = Math.min(characters.length, randomBetween(1, 3));
        while (chosen.size < count) chosen.add(characters[Math.floor(Math.random() * characters.length)]);
        chosen.forEach(span => span.setAttribute('data-science-active', 'true'));
        state.fadeTimer = window.setTimeout(() => chosen.forEach(span => span.removeAttribute('data-science-active')), randomBetween(700, 1000));
        schedule();
      };
      state.resume = schedule;
      state.cycleTimer = window.setTimeout(trigger, randomBetween(600, 2800));
    });
  }

  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.science-glow[data-science-glow-ready]').forEach(restore);
  });
  document.addEventListener('visibilitychange', () => {
    document.querySelectorAll('.science-glow[data-science-glow-ready]').forEach(heading => {
      const state = states.get(heading);
      if (!state) return;
      window.clearTimeout(state.cycleTimer);
      window.clearTimeout(state.fadeTimer);
      heading.querySelectorAll('[data-science-active]').forEach(span => span.removeAttribute('data-science-active'));
      if (!document.hidden) state.resume();
    });
  });
  reducedMotion.addEventListener('change', event => {
    if (event.matches) document.querySelectorAll('.science-glow[data-science-glow-ready]').forEach(restore);
    else initialize();
  });
})();
